// @ts-strict-ignore
import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { LMFormComponent } from '@form/lm-form.component';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMModel } from '@form/model';

@Component({
  selector:  'lm-select-record',
  standalone: false,
  template:  `
    @if (formSpec) {
      <lm-form #selectrecord
        [formUrlInfo]="formUrlInfo"
        [formSpec]="formSpec"
        [initDataView]="dataView"
        [formOptions]="formOptions"
        [ngStyle]="{'height': '100%'}"
        (formDisplayed)="onFormDisplayed($event)"
        >
      </lm-form>
    }
    `,
  providers: [ LMRouteComponentService ]
})

export class LMSelectRecordDialogComponent {
  @Input() formUrlInfo: LMFormUrlInfo;
  @Input() formSpec: LMFormSpec;
  @Input() dataView: LMDataView;
  @Input() formOptions: LMFormOptions;
  @Input() parentModel: LMModel;

  @ViewChild(forwardRef(() => LMFormComponent)) formComponent; // : LMFormComponent;

  constructor() {
  }

  onFormDisplayed(event) {
    setTimeout(() => {
      if (this.parentModel) {
        this.formComponent.model.applyState(this.parentModel);
      }
    }, 1);
  }
}
